import React, { useEffect, useRef, useState } from 'react';
import { useMobile } from '../../../hook/usePlatform';
import ResponsivePaddingWrapper, {
  ResponsiveFlexDirection,
} from '../../../component/responsive/responsivePaddingWrapper';
import {
  FontWeightType, HeadingLarge, LabelMedium, TitleLarge,
} from '../../../component/Text';
import { lineColor } from '../../../util/colors';

const ProgramService: React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;

  return (
    <div
      style={{
        borderTop: border,
        paddingInline: isMobile ? 32 : 0,
        paddingBlock: isMobile ? 24 : 160,
      }}
    >
      <ResponsivePaddingWrapper
        desktopPadding="15vw"
        style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}
      >

        <HeadingLarge fontWeight={FontWeightType.w800} style={{ marginBottom: 66 }}>프로그램 상세</HeadingLarge>
        <ResponsiveFlexDirection style={{ gap: 28, width: '100%' }}>
          <ProgramItem bgImage="/image/programs/consultant_bg.jpeg" title="전담 컨설턴트 배정" content={'전 과정을 함께하며 상담 및 매칭\n11가지 신원정보 검증 통한 신뢰성 검증'} />
          <ProgramItem bgImage="/image/programs/coaching_bg.jpeg" title="심리 상담 및 관계 코칭" content={'만남 전후의 심리적 준비와 관계 형성 지원\n관계 발전을 위한 전문적인 조언과 심리적 지원 제공'} />
        </ResponsiveFlexDirection>
        <ResponsiveFlexDirection style={{ gap: 28, width: '100%', marginBlock: 28 }}>
          <ProgramItem bgImage="/image/programs/styling_bg.jpeg" title="맞춤 스타일링" content="시니어를 위한 맞춤 헤어+메이크업+프로필 촬영" />
          <ProgramItem bgImage="/image/programs/offline_party_bg.jpeg" title="오프라인 미팅 파티" content={'자연스러운 인연을 만나기 위한 파티\n(프리미엄 300회원은 유로로 참가 가능)'} />
        </ResponsiveFlexDirection>
        <ResponsiveFlexDirection style={{ gap: 28, width: '100%' }}>
          <ProgramItem bgImage="/image/programs/sirup_coupon_bg.jpeg" title="시럽 앱 이용권" content="최대 600명의 이성에게 편지를 발송할 수 있는 시럽 앱 하트 지급" />
          <ProgramItem bgImage="/image/programs/mbti_test_bg.jpeg" title="국가공인 MBTI 검사" content="한국MBTI 연구소의 정식 검사와 보고서 제공" />
        </ResponsiveFlexDirection>
      </ResponsivePaddingWrapper>

    </div>
  );
};
interface ProgramItemType {
  bgImage:string;
  title:string;
  content:string;
}
const ProgramItem : React.FC<ProgramItemType> = (props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);
  useEffect(() => {
    setHeight((divRef.current?.offsetWidth ?? 1) / 2);
  }, []);
  return (
    <div
      ref={divRef}
      style={{
        position: 'relative',
        flex: 1,
        backgroundImage: `url(${props.bgImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',

      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          height,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
        }}
      >
        <TitleLarge fontWeight={FontWeightType.w800}>{props.title}</TitleLarge>
        <LabelMedium style={{ textAlign: 'center', fontFamily: 'inter', marginTop: 16 }}>{props.content}</LabelMedium>
      </div>
    </div>
  );
};
export default ProgramService;
